import { Component, Input, OnInit } from '@angular/core';
import { MemberQuery, PopulationQuery } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { calculateAge, getKidType, KidTypeT } from 'src/app/shared/utilities/age-ranges';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-desktop-nav-banner',
  templateUrl: './desktop-nav-banner.component.html',
  styleUrls: ['./desktop-nav-banner.component.scss'],
})
export class DesktopNavBannerComponent implements OnInit {
  @Input() pageName: string = '';
  @Input() imageName: string = '';
  @Input() forceDefaultBanner: boolean = false;
  screenSize = ScreenType;
  isClub1901: boolean = false;
  isKid: boolean = false;
  kidType$: Observable<KidTypeT>;

  constructor(private populationQuery: PopulationQuery, private memberQuery: MemberQuery) {}

  ngOnInit() {
    this.isClub1901 = this.populationQuery.userInPopulation([Populations.Club1901]);
    this.isKid = this.populationQuery.userInPopulation([Populations.Kids]);
    this.kidType$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => (m ? getKidType(calculateAge(new Date(m.DOB))) : 'Other'))
    );
  }
}
